import { render } from "./EventList.vue?vue&type=template&id=760c3b8e&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=760c3b8e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-760c3b8e"

export default script